module.exports = __webpack_public_path__ + "static/img/rdwd.573b93ec.png";